// extracted by mini-css-extract-plugin
export default {"root":"talent-portal_root__i5fvk","grid":"talent-portal_grid__CpGkc","sideBlock":"talent-portal_sideBlock__KzZgB"};